import React from "react";
import { fontSizeEnum, fontColorEnum } from "@/utils/enum";
import "@/assets/titleSection.css";

const TitleSection = ({ fields }) => {
  const titleFontSize = (() => {
    switch (fields?.titleFontSize?.value?.toLowerCase()) {
      case fontSizeEnum.middle:
        return "title-font-size-middle";
      case fontSizeEnum.small:
        return "title-font-size-small";
      default:
        return "title-font-size-big";
    }
  })();
  const titleFontColor = (() => {
    switch (fields?.titleFontColor?.value?.toLowerCase()) {
      case fontColorEnum.blue:
        return "title-font-color-blue";
      case fontColorEnum.red:
        return "title-font-color-red";
      default:
        return "title-font-color-black";
    }
  })();

  return (
    <div
      className={`title-margin-bottom ${titleFontSize} ${titleFontColor}`}
      dangerouslySetInnerHTML={{
        __html: fields?.Rtitle?.value,
      }}
    />
  );
};

export default TitleSection;
